import { MessageCircle } from "lucide-react";

export const FloatingWhatsApp = ({ onClick }) => (
  <button
    data-testid="floating-whatsapp"
    onClick={onClick}
    aria-label="Falar no WhatsApp"
    className="wa-ping fixed bottom-6 left-6 z-50 bg-[#25D366] hover:bg-[#1EBE5D] text-white p-4 rounded-full shadow-[0_4px_20px_rgba(37,211,102,0.5)] transition-transform hover:scale-110 flex items-center justify-center"
  >
    <MessageCircle className="w-7 h-7" />
  </button>
);
